/**
 * @generated SignedSource<<5d4bf94b0ece174f26d71167e1c88cf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InviteeRelationship = "MANAGER" | "SUBORDINATE" | "TEAMMATE";
export type InviteUsersMutationInput = {
  analytics: string;
  captchaToken: string;
  clientMutationId?: string | null;
  invitations: ReadonlyArray<InviteUserInput | null>;
};
export type InviteUserInput = {
  email: string;
  fullName: string;
  oneOnOneDetails?: InviteOneOnOneInput | null;
  relationship?: InviteeRelationship | null;
  sendInviteEmail?: boolean | null;
};
export type InviteOneOnOneInput = {
  eventEnd?: string | null;
  eventId?: string | null;
  eventStart?: string | null;
};
export type ToggleArchiveMultipleNoteStreamsInput = {
  clientMutationId?: string | null;
  notestreamIds: ReadonlyArray<string | null>;
  value?: boolean | null;
};
export type OneOnOneInviteUsersMutation$variables = {
  invite: InviteUsersMutationInput;
  toggle: ToggleArchiveMultipleNoteStreamsInput;
};
export type OneOnOneInviteUsersMutation$data = {
  readonly inviteUsers: {
    readonly invitees: ReadonlyArray<{
      readonly errors: ReadonlyArray<{
        readonly field: string | null;
        readonly message: string;
      } | null> | null;
      readonly streamEdge: {
        readonly cursor: string;
        readonly node: {
          readonly id: string;
          readonly otherUser: {
            readonly department: string | null;
            readonly email: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly internalAttributes: {
              readonly manager: {
                readonly fullName: string;
                readonly id: string;
              } | null;
            } | null;
            readonly isActive: boolean;
            readonly isConfigured: boolean;
            readonly isGuest: boolean;
            readonly title: string | null;
          } | null;
          readonly url: string | null;
        } | null;
      } | null;
      readonly user: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly isConfigured: boolean;
      } | null;
    }>;
  } | null;
  readonly toggleArchiveMultiple: {
    readonly noteStreams: ReadonlyArray<{
      readonly archived: boolean | null;
      readonly id: string;
      readonly index: number | null;
      readonly starOrder: number | null;
      readonly starred: boolean;
      readonly url: string | null;
    }>;
  } | null;
};
export type OneOnOneInviteUsersMutation = {
  response: OneOnOneInviteUsersMutation$data;
  variables: OneOnOneInviteUsersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "invite"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toggle"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "invite"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "FormError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "department",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "manager",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "input",
      "variableName": "toggle"
    }
  ],
  "concreteType": "ToggleArchiveMultipleNoteStreamsPayload",
  "kind": "LinkedField",
  "name": "toggleArchiveMultiple",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "noteStreams",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "index",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "archived",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "starOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "starred",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OneOnOneInviteUsersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InviteUsersMutationPayload",
        "kind": "LinkedField",
        "name": "inviteUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InviteUserOutput",
            "kind": "LinkedField",
            "name": "invitees",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStreamEdge",
                "kind": "LinkedField",
                "name": "streamEdge",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStream",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "otherUser",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v16/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OneOnOneInviteUsersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InviteUsersMutationPayload",
        "kind": "LinkedField",
        "name": "inviteUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InviteUserOutput",
            "kind": "LinkedField",
            "name": "invitees",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteStreamEdge",
                "kind": "LinkedField",
                "name": "streamEdge",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteStream",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "otherUser",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v16/*: any*/)
    ]
  },
  "params": {
    "cacheID": "7f544af455748002cd8433e552e3530c",
    "id": null,
    "metadata": {},
    "name": "OneOnOneInviteUsersMutation",
    "operationKind": "mutation",
    "text": "mutation OneOnOneInviteUsersMutation(\n  $invite: InviteUsersMutationInput!\n  $toggle: ToggleArchiveMultipleNoteStreamsInput!\n) {\n  inviteUsers(input: $invite) {\n    invitees {\n      errors {\n        field\n        message\n      }\n      streamEdge {\n        cursor\n        node {\n          id\n          url\n          otherUser {\n            id\n            email\n            fullName\n            image\n            title\n            department\n            isActive\n            isConfigured\n            isGuest\n            internalAttributes {\n              manager {\n                id\n                fullName\n              }\n              id\n            }\n          }\n        }\n      }\n      user {\n        id\n        email\n        fullName\n        isConfigured\n      }\n    }\n  }\n  toggleArchiveMultiple(input: $toggle) {\n    noteStreams {\n      id\n      url\n      index\n      archived\n      starOrder\n      starred\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0abfc03614a88a5fad99a2ea32d6ae31";

export default node;
